export default __webpack_public_path__ + "static/media/fmb920.4a357fdb.png";